import { render, staticRenderFns } from "./addKnowledgeBase.vue?vue&type=template&id=19693ee4&"
import script from "./addKnowledgeBase.vue?vue&type=script&lang=js&"
export * from "./addKnowledgeBase.vue?vue&type=script&lang=js&"
import style0 from "./addKnowledgeBase.vue?vue&type=style&index=0&id=19693ee4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports